import { render, staticRenderFns } from "./InvitationPreviewPopup.vue?vue&type=template&id=5c0c1dcf"
import script from "./InvitationPreviewPopup.vue?vue&type=script&lang=ts"
export * from "./InvitationPreviewPopup.vue?vue&type=script&lang=ts"
import style0 from "./InvitationPreviewPopup.vue?vue&type=style&index=0&id=5c0c1dcf&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports